<template>
  <base-section
    id="topics"
  >
    <base-section-heading
      title="Topics"
    />
    <v-container>
      <base-section-heading
      divider=null
      >
      Here you can find the list of the topics (not limited to) for ETS'23. There are also some <strong>hot topics</strong> that refer to the newest trends in the Testing community. They are valid for scientific papers, students submissions and fringe workshops proposals.
      </base-section-heading>
      <v-card
        class="mx-auto"
        tile
      >
        <v-list>
          <v-list-group
            v-for="item in items"
            :key="item.title"
            v-model="item.active"
            :prepend-icon="item.action"
            no-action
          >
            <template #activator>
              <v-list-item-content>
                <v-list-item-title v-text="item.title" />
              </v-list-item-content>
            </template>

            <v-list-item-content>
              <v-card-text>
                {{ item.description }}
                <br><br>
                <strong>Subtopics</strong>
                <v-chip-group
                  column
                >
                  <v-chip
                    v-for="(subt,i) in item.subtopics"
                    :key="i"
                    label
                    active-class="chip-active"
                    :ripple="false"
                    style="cursor: default !important; height: auto; white-space: normal !important"
                    class="ma-2 pa-2"
                  >
                    {{ subt }}
                  </v-chip>
                </v-chip-group>
              </v-card-text>
            </v-list-item-content>
          </v-list-group>
        </v-list>
      </v-card>
       <br>
      <br>
        <v-footer
          id="program-footer"
          color="primary"
          dark
          min-height="72"
          class="hidden-md-and-up"
        >
          <v-container>
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <div class="d-flex flex-wrap justify-md-start justify-center justify-md-none">
                  <template v-for="(s, i) in submissionsfooter">
                    <router-link
                      :key="s.name"
                      class="white--text pa-1 pa-md-0"
                      :to="s.url"
                      v-text="s.name"
                    />

                    <v-responsive
                      v-if="i < submissionsfooter.length - 1"
                      :key="`divider-${s.name}`"
                      class="mx-4 shrink hidden-sm-and-down"
                      max-height="24"
                    >
                      <v-divider vertical />
                    </v-responsive>
                  </template>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-footer>
    </v-container>
  </base-section>
</template>
<script>
  export default {
    name: 'Topics',

    data: () => ({
      isMobile: false,
      submissionsfooter: [
        {
          name: 'Submissions',
          url: 'submissions',
        },
        {
          name: 'Key Dates',
          url: 'key-dates',
        },
        {
          name: 'Topics',
          url: 'topics',
        },
        {
          name: 'Submit a Paper',
          url: 'cfp',
        },
        {
          name: 'Submission Guidelines',
          url: 'submission-guidelines',
        },
      ],
      items: [
        {
          items: [{ title: 'List Item' }],
          title: 'Dependable AI and AI for Testing (Hot Topic)',
          description: 'AI/ML is thriving across numerous applications and we are only at the beginning of the revolution. Not surprisingly, AI/ML is gaining popularity for solving dependability and testing problems for ICs. In parallel, we need to address the problem of dependability and testing of emerging AI hardware accelerators.',
          subtopics: [
            'Fault modeling and reliability assessment of AI/ML hardware',
            'Structural and functional testing of AI/ML hardware',
            'On-line test, fault-tolerance, and error-resiliency of AI/ML hardware',
            'AI/ML applications to IC manufacturing testing',
            'AI/ML applications to IC reliability',
            'AI/ML applications to IC fault diagnosis and failure analysis',
            'AI/ML applications to IC on-line testing, anomaly detection, and functional safety',
          ],
        },
        {
          items: [
            { title: 'Breakfast & brunch' },
            { title: 'New American' },
            { title: 'Sushi' },
          ],
          title: 'Functional Safety and Reliability in Automotive (Hot Topic)',
          description: 'Automotive electronics architectures are becoming more integrated and increasingly complex to achieve leading-edge functionality. Proper test, methods and diagnostics at all levels as well as innovative methods for reliable, safe, and secure operation in the field are needed to comply with functional safety and reliability challenges.',
          subtopics: [
            'Dependability',
            'Defect mechanisms',
            'Design for Reliability',
            'Fault Modeling and Simulation',
            'Yield Analysis and Enhancement Safety',
            'Reliability',
          ],
        },
        {
          items: [{ title: 'List Item' }],
          title: 'Emerging technologies and architectures (Hot Topic)',
          description: 'Until now, the innovation of computing devices has relied on incremental improvements in technology and architecture. However, it has become apparent that a paradigm shift is needed to enable new performance breakthroughs, such as novel processing and computing paradigms and non-CMOS-based technology.',
          subtopics: [
            'Approximate Circuits',
            'In-memory Computing',
            'Neuromorphic Architectures',
            'Photonics Devices and Architectures',
            'Quantum and Reversible Circuits and Architectures',
          ],
        },
        {
          items: [{ title: 'List Item' }],
          title: 'Security and Trust (Hot Topic)',
          description: 'The widespread use of electronic devices in critical and multitenant applications brings as a major requirement the assurance of security and trust. However, with the growing complexity of the electronic systems design, the risk of malware infections, vulnerabilities and Trojans introduced at design time increases significantly. Proper methods that address security and trust issues by design as well as innovative solutions for thevarious security aspects of electronic devices are mandatory.',
          subtopics: [
            'Methods, tools and use cases on Design for Security',
            'Test methods for secure systems (e.g., cryptographic primitives, RNGs, PUFs)',
            'Test infrastructures for secure devices',
            'Secure design methods against physical attacks (e.g., fault attacks, side channels)',
            'Security Issues in Test (attacks and countermeasures)',
            'Trusted hardware design and manufacturing',
            'Hardware Trojans, detection and countermeasures',
          ],
        },
        {
          items: [{ title: 'List Item' }],
          title: 'Analog, Mixed-Signal, RF',
          description: 'Despite many years of research efforts, Analog, Mixed-Signal and RF test remains highly circuit-specific. The complexity of the problem stems from both the diversity of performance specifications and the sensitivity to any change in the signal path. However, AMS-RF researchers are undeterred, and this topic will bring together their latest advances.',
          subtopics: [
            'Analog and Mixed-Signal',
            'High-Speed digital',
            'MEMS sensors',
            'RF',
          ],
        },
        {
          items: [{ title: 'List Item' }],
          title: 'DfT and Test Access Standards',
          description: 'Design for Testability (DFT) solutions are needed to provide the circuit access required to achieve ultra-low defect levels at manufacturing and enable the detection of new failures later in the field.  Updated standards for secure and effective test are also needed to ensure interoperability.',
          subtopics: [
            'Built-In Self-Test',
            'NoC, SoC',
            'Design for Test',
            'Standards',
            '3D-Test & Chiplets',
          ],
        },
        {
          items: [{ title: 'List Item' }],
          title: 'Validation, Verification Debug and Diagnosis',
          description: 'Methodologies and tools for validation, verification, debug and diagnosis of SoCs, cyber-physical systems and emerging architectures, from circuit to system level, including embedded software from edge to cloud, by exploiting formal, semi-formal and dynamic approaches, with or without the use of artificial intelligence and machine learning techniques.',
          subtopics: [
            'Testbench and assertion generation and qualification, including coverage metrics',
            'Fault/mutant modeling and simulation,',
            'Checker synthesis and optimization,',
            'Multi-domain and mixed-critical validation and verification techniques,',
            'Pre- and post-silicon diagnosis and debugging solutions,',
            'Security verification and detection of vulnerabilities,',
            'Formal verification techniques like equivalence checking, model checking and theorem proving,',
            'Core algorithmic technologies supporting formal verification such as SAT and SMT techniques,',
            'Acceleration-driven and emulation-based approaches for verification and diagnosis',
            'System-level testing',
            'Artificial intelligence in test generation and response analysis',
            'Verification and validation of safety mechanisms',
          ],
        },
        {
          items: [{ title: 'List Item' }],
          title: 'Test generation, Fault Simulation, Fault Tolerance, Application and evaluation',
          description: 'Test generation and fault simulation techniques across various abstraction levels, e.g. cell-aware, gate-level, system-level, as well as for different fault models, e.g. traditional, defect-oriented and transient. Fault tolerance techniques such as online testing. Adaptive and defect-oriented testing.',
          subtopics: [
            'Fault Tolerance',
            'On-Line Testing',
            'Self-Repair',
            'Adaptive Testing',
            'Automatic Test Pattern Generation (ATPG)',
            'Defect-oriented Testing',
            'Fault Simulation',
            'Transient Faults',
            'System-level Test',
            'Solving Techniques',
            'Delay Testing',
          ],
        },
        {
          title: 'Special Tracks',
          items: [{ title: 'List Item' }],
          subtopics: [
            'Special Track on Dependable RISC-V',
            'Special Track on Dependable Autonomous Systems',
          ],
        },
      ],
      mounted () {
        this.isMobile = (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
      },
      methods: {
        isMobileDevice () {
          return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
        },
      },
    }),
  }
</script>
<style scoped>
.chip-active {
    background: #e0e0e0;
    background-color:rgb(224 224 224 / 50%);
    color: rgba(0, 0, 0, 0.87) !important;
    border-color: rgba(0, 0, 0, 0.12);

}
</style>
